import React from 'react'
import styled, { DefaultTheme, css } from 'styled-components'

import { Image } from '../../Image'
import { Text } from '../../Text'
import { ThemeWrapper } from '../../theme'

type MenuLinkType = 'primary' | 'secondary' | 'transparent' | 'primaryDark'

const getBackgroundColorByType = (type: MenuLinkType, theme: DefaultTheme) => {
  const colors = {
    primary: 'primary',
    primaryDark: 'primaryDark',
    secondary: 'white',
    transparent: 'transparent'
  }

  // @ts-ignore
  return theme.colors[colors[type] || 'primary']
}

const getTextColorByType = (type: MenuLinkType) => {
  const colors = {
    primary: 'white',
    primaryDark: 'white',
    secondary: 'primary',
    transparent: 'white'
  }
  return colors[type] || 'white'
}

const MenuLinkWrapper = styled.div<{
  type: MenuLinkType
  justifyContent?: string
  separator?: boolean
  isLink?: boolean
}>`
  justify-content: ${({ justifyContent }) => justifyContent || 'space-between'};
  background: ${({ type, theme }) => getBackgroundColorByType(type, theme)};
  align-items: center;
  height: 60px;
  padding: 16px;
  display: flex;
  position: relative;
  ${({ isLink }) =>
    isLink &&
    css`
      cursor: pointer;
    `}

  &::before {
    position: absolute;
    bottom: 0;
    content: '';
    display: ${({ separator }) => (separator ? `block` : 'none')};
    width: calc(100% - 32px);
    height: 1px;
    background-color: ${({ type }) => getTextColorByType(type)};
    opacity: 0.5;
  }
`

type MobileMenuLinkProps = React.PropsWithChildren<{
  text?: string
  icon?: string
  type?: MenuLinkType
  justifyContent?: string
  separator?: boolean
  isLink?: boolean
}> &
  React.InsHTMLAttributes<HTMLDivElement>

export const MobileMenuItem = ({
  text,
  icon,
  type = 'primary',
  justifyContent,
  children,
  separator,
  isLink,
  ...rest
}: MobileMenuLinkProps) => {
  return (
    <ThemeWrapper>
      <MenuLinkWrapper type={type} justifyContent={justifyContent} separator={separator} isLink={isLink} {...rest}>
        {text && (
          <Text color={getTextColorByType(type)} bold>
            {text}
          </Text>
        )}
        {children}
        {icon && <Image alt="icon" type={icon} />}
      </MenuLinkWrapper>
    </ThemeWrapper>
  )
}
